import { Component, Inject, ChangeDetectionStrategy } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ImageMoveWarningDialogData {
    title: string;
    body: string;
    confirmLabel?: string;
    cancelLabel?: string;
}

@Component({
    selector: 'pv-image-move-warning-dialog',
    templateUrl: 'image-move-warning.dialog.html',
    styleUrls: ['image-move-warning.dialog.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    preserveWhitespaces: false,
})
export class ImageMoveWarningDialog {

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: ImageMoveWarningDialogData,
        private _ref: MatDialogRef<ImageMoveWarningDialog>,
    ) { }

    confirm() {
        this._ref.close(true);
    }

    cancel() {
        this._ref.close(false);
    }
}
